import { Dispatch, SetStateAction, createContext } from 'react';

interface DrawerContextData {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const DrawerContext = createContext<DrawerContextData>(
  {} as DrawerContextData
);
